import React from 'react';
import { GRID_COLUMNS } from '../utils/proposalSectionColumns';
import styles from './LayoutPreview.module.css';

/**
 * Aperçu d'une disposition : des cases pleines, réparties comme les colonnes
 * et les lignes qu'elles représentent.
 *
 * **Ce composant ne fait que le style.** Il ne sait rien des dispositions de
 * Bloc, ni des compositions de la palette : il reçoit un arbre de poids et le
 * dessine. Ses deux appelants — le sélecteur de disposition d'un Bloc
 * (`puck/fields/SectionLayoutPresetPicker`) et le croquis d'une composition
 * (`puck/palette/CompositionSketch`) — traduisent chacun leurs données vers
 * cette forme. Deux dessins différents pour le même geste, et l'utilisateur y
 * verrait deux fonctionnalités.
 *
 * Forme attendue :
 *
 *   colonnes = [{ weight, rows: [[{ weight, content }]] }]
 *
 * `rows` est facultatif : une colonne sans lignes est une case unique.
 * `content` est facultatif : ce que la case porte (une icône, un « ? »).
 *
 * @param {Array} columns colonnes de l'aperçu
 * @param {boolean} [selected] état sélectionné (bleu)
 */
export default function LayoutPreview({ columns = [], selected = false }) {
  return (
    <div className={`${styles.preview} ${selected ? styles.previewSelected : ''}`}>
      {columns.map((column, columnIdx) => {
        const rows = column.rows?.length ? column.rows : [[column]];
        return (
          <div
            key={columnIdx}
            className={styles.column}
            style={{
              flexGrow: column.weight,
              flexBasis: `${(column.weight / GRID_COLUMNS) * 100}%`,
            }}
          >
            {rows.map((row, rowIdx) => (
              <div key={rowIdx} className={styles.row}>
                {row.map((cell, cellIdx) => (
                  <div
                    key={cellIdx}
                    className={styles.cell}
                    style={{ flexGrow: cell.weight }}
                  >
                    {cell.content}
                  </div>
                ))}
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}
